import { UsersService } from '../services/users.service';
import { Component, OnInit, Input, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { Router } from "@angular/router";
import { AuthService } from 'src/app/bo/services/auth.service';

@Component({
    selector: 'app-account-deletion',
    templateUrl: './account-deletion.component.html',
    styleUrls: ['./account-deletion.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountDeletionComponent implements OnInit {

    @BlockUI() blockUI: NgBlockUI;
    @Input() id: string;

    infos: any = {
        email: "",
        pass: "",
    }

    constructor(
        public activeModal: NgbActiveModal,
        private toastrService: ToastrService,
        private usersService: UsersService,
        private router: Router,
        public authService: AuthService,
    ) { }

    ngOnInit(): void {
		this.getUserById();
    }
    signOut() {
        this.authService.signOut();
        this.router.navigate(['/bo/connexion']);
    }


    getUserById(): void {
        this.blockUI.start('Loading');
        this.usersService.getCoreUserById(this.id).subscribe(
            (res) => {
                if (res.success) {
                    this.infos.email = res.data.email;
                    this.blockUI.stop();
                } else {
                    this.blockUI.stop();
                    if (res.errorSet.includes('InvalidRequest')) {
                        this.toastrService.error('Les paramètres sont invalides');
                    } else if (res.errorSet.includes('NotFound')) {
                        this.toastrService.error('Utilisateur non trouvé');
                    }
                }
            },
            (error) => {
                this.blockUI.stop();
                // console.error(error);
                this.toastrService.error('Une erreur s\'est produite');
            }
        );
    }

    deleteAccount(): void {
        this.blockUI.start('Loading');
        if (!this.infos.email || !this.infos.pass) {
            this.toastrService.error('Veuillez remplir les champs manquants');
            this.blockUI.stop();
        } else {
            this.activeModal.close();
            console.log(this.infos)
            this.usersService.deleteCoreUser(this.infos.email, this.infos.pass).subscribe(
                (res: any) => {
                    if (res.success) {
                        this.toastrService.success('Supprimé avec succès.');
                        this.signOut();
                        this.blockUI.stop();
                    } else {
                        this.blockUI.stop();
                        if (res.errorSet.includes('INVALID_PARAMS') || res.errorSet.includes('INVALID_REQUEST')) {
                            this.toastrService.error('Les paramètres sont invalides');
                        } else if (res.errorSet.includes('NOTFOUND')) {
                            this.toastrService.error('Utilisateur non trouvé');
                        } else if (res.errorSet.includes('ERROR_SERVER') || res.errorSet.includes('SERVER_ERROR')) {
                            this.toastrService.error('Une erreur serveur est survenue');
                        } else {
                            this.toastrService.error('Une erreur est survenue');
                        }
                    }
                },
                (error) => {
                    this.blockUI.stop();
                     console.log(error);
                    this.toastrService.error('Une erreur s\'est produite');
                }
            );
        }
    }
}
